import React, { useState, useEffect, useContext } from "react";
import Currency from "./Currency/Currency";
import { FaFire, FaHome, FaCrown, FaGlobe, FaBars, FaBlog } from "react-icons/fa";
import { translations } from "../translation/translation";
import { LangContext } from "../translation/langugeContext";

const Header = ({ routingFlag, blur, pageData }) => {
  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const { lang, toggleLang } = useContext(LangContext);
  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const t = translations[lang];

  return (
    <>
      <nav
        className={`fixed top-0 w-full z-40 transition-all duration-300 bg-[#11132F]/90 
          ${blur ? "blur-nav" : "main-nav"}`}
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-2 mobile-padding">
            <div className="logo flex items-center gap-4">
              <div className="logo-container">
                <img
                  src="/img/logo3copy.png"
                  alt="Signature Icon"
                  className="h-12"
                />
                <img
                  src="/img/logocopy.png"
                  alt="Signature Logo"
                  className="h-24 main-logo"
                />
              </div>
            </div>

            {/* disktop links */}
            <div className="md:hidden hidden lg:flex items-center">
              <a href={routingFlag ? "/" : "#home"} className="nav-link">
                <FaHome className="inline mr-1" />
                <span>{t.home}</span>
              </a>
              <a
                href={
                  routingFlag
                    ? "/property-browser?filter_type=hot"
                    : "#hot-offers"
                }
                className="nav-link hot-offers-link relative"
              >
                <FaFire className="inline mr-1 text-red-600 text-lg" />
                <span>
                  <span className="text-red-600 font-bold">{t.hotLabel}</span>{" "}
                  <span className="text-[var(--accent-yellow)] font-bold">
                    {t.offersLabel}
                  </span>
                </span>
              </a>
              <a
                href={
                  routingFlag
                    ? "/property-browser?filter_type=featured"
                    : "#featured"
                }
                className="nav-link"
              >
                <FaHome className="inline mr-1" />
                <span>{t.featured}</span>
              </a>
              <a
                href={
                  routingFlag
                    ? "/property-browser?filter_type=luxury"
                    : "#luxury-properties"
                }
                className="nav-link"
              >
                <FaCrown className="inline mr-1" />
                <span>{t.luxury}</span>
              </a>
              <a
                href={routingFlag ? "/blogs" : "#articals"}
                className="nav-link"
              >
                <FaBlog className="inline mr-1" />
                <span>{t.articles}</span>
              </a>
                <Currency  pageData={pageData}/>

                <button className="language-toggle flex items-center" onClick={toggleLang}>
                <FaGlobe className="inline mr-1" />
                <span>{t.toggleLang}</span>
              </button>
            </div> 

            {/* menu button and drop down list*/}
            <div className="relative md:hidden">
             {/* currency on mobile */}
            <div className="currency-mobile">
              <Currency pageData={pageData}/>
              <button className="mobile-menu-button" onClick={toggleMobileMenu}>
                <FaBars className="fabars" />
              </button>
              {mobileMenuOpen && (
                <div className="mobile-dropdown">
                  <ul className="mobile-menu-list">
                    <li>
                      <button className="language-toggle flex mobile-menu-link" onClick={toggleLang}>
                        <FaGlobe className="inline mr-1"/>
                        <span >{t.toggleLang}</span>
                      </button>
                    </li>
                    <li>
                      <a
                        href={routingFlag ? "/" : "#home"}
                        className="mobile-menu-link"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <FaHome />
                        <span>{t.home}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={routingFlag ? "/property-browser?filter_type=hot" : "#hot-offers"}
                        className="mobile-menu-link"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <FaFire className="hot-icon" />
                        <span>
                          <span className="hot-text">{t.hotLabel}</span>{" "}
                          <span className="offer-text">{t.offersLabel}</span>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={routingFlag ? "/property-browser?filter_type=featured" : "#featured"}
                        className="mobile-menu-link"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <FaHome />
                        <span> {t.featured}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          routingFlag
                            ? "/property-browser?filter_type=luxury"
                            : "#luxury-properties"
                        }
                        className="mobile-menu-link"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <FaCrown />
                        <span>{t.luxury}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={routingFlag ? "/blogs" : "#articals"}
                        className="mobile-menu-link"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <FaBlog />
                        <span>{t.articles}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
          </div>
      </nav>
    </>
  );
};

export default Header;
